import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from "vue-router";
  import { ArrowLeft } from "lucide-vue-next";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PageBackButton',
  setup(__props, { expose: __expose }) {
  __expose();

  const router = useRouter();

  const handleClick = () => {
    let navigated = false;
    const removeGuard = router.afterEach((to) => {
      navigated = true;
      removeGuard();

      if (to.query.embed !== "true") {
        router.replace({ ...to, query: { ...to.query, embed: "true" } });
      }
    });

    router.back();
    setTimeout(() => {
      if (!navigated) removeGuard();
    }, 100);
  };

const __returned__ = { router, handleClick, get useRouter() { return useRouter }, get ArrowLeft() { return ArrowLeft } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})